<template>
  <div>
    <span :class="iconClassFinal" @click.self="emitValue($event)"></span>
  </div>
</template>

<script>
export default {
  name: 'bh-icon',
  props: {
    iconClass: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconClassFinal: {
      get() {
        return `font-icon icon-${this.icon} ${this.iconClass}`
      }
    }
  },
  methods: {
    emitValue(event) {
      this.$emit('output', event)
    }
  }
}
</script>

<style scoped>
  .font-icon {
    vertical-align: middle;
  }
</style>
